import { ChildrenItems } from './../shared/menu-items/gt-menu-items';
import { AngularFireAuth } from 'angularfire2/auth';
import { User } from './../models/user';
import { Injectable } from '@angular/core';
import { AngularFireDatabase, FirebaseListObservable, FirebaseObjectObservable } from 'angularfire2/database';
import { Observable } from 'rxjs';

@Injectable()
export class UsersService {

  users: FirebaseListObservable<any[]>;
  user: FirebaseObjectObservable<any>;

  constructor(
    public af:AngularFireDatabase,
    public afauth: AngularFireAuth

  ) {
    this.users = this.af.list('/users') as FirebaseListObservable<User[]>;
  }

  getUsers(){
    return this.users;
  }

  getUser(id:string){
    return this.af.object('/users/'+id) as FirebaseObjectObservable<User>;
  }

  getUserCompanies(id:string, limit:number = 15){
    return this.af.list('/members_company/'+id,{
      query: {
        orderByKey: true,
        limitToLast: limit,
      }
    }) as FirebaseListObservable<any[]>;
  }

  multiChangeUser(cid:string, id:string, value:any){

   return this.users.update(id, value)
      .then(() => {
        this.af.list('/companies/' + cid + '/members').update(id, value);
      })
      .catch(err => console.log('erreur maj utilisateur'));
    //return this.users.update(id, value);
}

  updataLogin(id:string){
    this.af.list('/users/' + id +'/last_logins').push({loginAt: new Date().getTime()});
   // this.af.object('/users/'+ id + 'last_logins').push({loginAt: new Date().getTime()});
}

  updateUser(id:string, utilisateur:User){
    return this.users.update(id, utilisateur);
  }

  setUserWithCompany(value: any){
    return this.users.update(this.afauth.auth.currentUser.uid , value);
  }

  itemChangeUser(id:string, value:any){
    return this.users.update(id, value);
  }

  updateRaw(id:string, data: any){
    return this.users.update(id, data);
 }

  newUser( utilisateur:User){
      return this.users.push(utilisateur);
  }

  deleteUser(id:string){
    return this.users.remove(id);
  }
}



// WEBPACK FOOTER //
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/src/app/services/users.service.ts